/**
 * Modal de galería — sección Infraestructura (portada).
 */
export function marianistaInitInfraModal() {
  const modal = document.getElementById('infraModal');
  if (!modal) {
    return;
  }

  const backdrop = modal.querySelector('.infra-modal__backdrop');
  const closeBtn = modal.querySelector('.infra-modal__close');
  const titleEl = modal.querySelector('.infra-modal__titulo');
  const panels = modal.querySelectorAll('[data-infra-panel]');
  const triggers = document.querySelectorAll('[data-infra-modal]');
  const splideMap = new WeakMap();

  let activePanel = null;

  function mountSplide(panel) {
    const root = panel.querySelector('.infra-modal__splide');
    if (!root || typeof Splide === 'undefined') {
      return null;
    }

    if (splideMap.has(root)) {
      const existing = splideMap.get(root);
      existing.go(0);
      return existing;
    }

    const splide = new Splide(root, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: 0,
      pagination: true,
      arrows: true,
      keyboard: true,
      drag: true,
    });
    splide.mount();
    splideMap.set(root, splide);

    return splide;
  }

  function showPanel(index) {
    const panel = modal.querySelector(`[data-infra-panel="${index}"]`);
    if (!panel) {
      return;
    }

    panels.forEach((p) => {
      p.hidden = p !== panel;
    });
    activePanel = panel;
    mountSplide(panel);
  }

  function openModal(index, titulo) {
    const panel = modal.querySelector(`[data-infra-panel="${index}"]`);
    if (!panel || panel.dataset.infraEmpty === '1') {
      return;
    }

    if (titleEl) {
      titleEl.textContent = titulo || '';
    }

    showPanel(index);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn?.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    activePanel = null;
  }

  triggers.forEach((btn) => {
    btn.addEventListener('click', () => {
      const index = btn.getAttribute('data-infra-index');
      const titulo = btn.getAttribute('data-infra-titulo') || '';
      if (index === null || index === '') {
        return;
      }
      openModal(index, titulo);
    });
  });

  backdrop?.addEventListener('click', closeModal);
  closeBtn?.addEventListener('click', closeModal);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
}
